module.exports = __webpack_public_path__ + "static/media/background.b7f0df25.svg";